import React__default from 'react';
import { useFormSlot } from '../../../../slots/forms/form-context.js';

const ExpressCheckoutFormContainer = ()=>{
    const { expressCheckout  } = useFormSlot();
    if (!expressCheckout) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-checkout-form-container"
    }, expressCheckout);
};

export { ExpressCheckoutFormContainer };
//# sourceMappingURL=ExpressCheckoutFormContainer.js.map
